var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"pill",class:{ 'text-outline': _vm.outline },attrs:{"id":"pill"}},[_vm._v(_vm._s(_setup.props.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }